import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Environment } from 'src/app/shared/models/environment';
import { eventApiUrl } from './serviceUrl.constant';

@Injectable({
  providedIn: 'root',
})
export class EventsService {
  public environment = Environment.getInstance();
  private isEventReceiverFlagSubject = new BehaviorSubject<boolean>(false);
  public isEventReceiverFlag$: Observable<boolean> =
    this.isEventReceiverFlagSubject.asObservable();

  eventGetRequestBody = {
    baseUrl: '',
    urlEndPoint: '',
    method: 'get',
  };

  eventPostRequestBody = {
    baseUrl: '',
    urlEndPoint: '',
    method: 'POST',
    data: null,
  };

  masterGetRequestBody = {
    baseUrl: '',
    urlEndPoint: '',
    method: 'get',
  };

  masterPostRequestBody = {
    baseUrl: '',
    urlEndPoint: '',
    method: 'POST',
    data: null,
  };

  masterPutRequestBody = {
    baseUrl: '',
    urlEndPoint: '',
    method: 'put',
    data: null,
  };

  workflowGetRequestBody = {
    baseUrl: '',
    urlEndPoint: '',
    method: 'get',
  };

  workflowPostRequestBody = {
    baseUrl: '',
    urlEndPoint: '',
    method: 'POST',
    data: null,
  };

  workflowPutRequestBody = {
    baseUrl: '',
    urlEndPoint: '',
    method: 'put',
    data: null,
  };

  userGetRequestBody = {
    baseUrl: '',
    urlEndPoint: '',
    method: 'get',
  };

  userPostRequestBody = {
    baseUrl: '',
    urlEndPoint: '',
    method: 'POST',
    data: null,
  };

  constructor(private http: HttpClient) {}

  getPermissions() {
    return this.http.get<any>(
      `${this.environment.apiConfig.holdUrl}masterdata/api/v1/hrm/master/userRolePermission`
    );
  }

  getEventNumber() {
    this.eventGetRequestBody['urlEndPoint'] = '/api/v1/hrm/events/eventNumber';
    this.eventGetRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventGetRequestBody
    );
  }

  getDashboardData(data) {
    this.eventPostRequestBody['urlEndPoint'] =
      '/api/v1/hrm/events/eventDashboard';
    this.eventPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    this.eventPostRequestBody['data'] = JSON.stringify(data);
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventPostRequestBody
    );
  }

  saveqraApproverEvent(data) {
    this.eventPostRequestBody['urlEndPoint'] = '/api/v1/hrm/events/qraApprover';
    this.eventPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    this.eventPostRequestBody['data'] = JSON.stringify(data);
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventPostRequestBody
    );
  }

  preSelectedDCs(eventType, param) {
    this.masterGetRequestBody['urlEndPoint'] =
      '/api/v1/hrm/master/inventoryDcMapping/inventorySystem/' +
      eventType +
      '/' +
      param;
    this.masterGetRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'masterdata';
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.masterGetRequestBody
    );
  }

  getQraApproverCatagory() {
    this.masterGetRequestBody['urlEndPoint'] =
      '/api/v1/hrm/master/getQraApprovals';
    this.masterGetRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'masterdata';
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.masterGetRequestBody
    );
  }

  getAppTaskCategory() {
    this.masterGetRequestBody['urlEndPoint'] =
      '/api/v1/hrm/master/productCategory';
    this.masterGetRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'masterdata';
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.masterGetRequestBody
    );
  }

  getProductCatageory() {
    this.masterGetRequestBody['urlEndPoint'] =
      '/api/v1/hrm/master/productCategory';
    this.masterGetRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'masterdata';
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.masterGetRequestBody
    );
  }

  getProductLookupData(productLookupData): Observable<any> {
    this.masterPostRequestBody['urlEndPoint'] =
      '/api/v1/hrm/master/allProductDetails';
    this.masterPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'masterdata';
    this.masterPostRequestBody['data'] = JSON.stringify(productLookupData);
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.masterPostRequestBody
    );
  }

  getItemDescriptionData(itemDescriptionData) {
    this.masterPostRequestBody['urlEndPoint'] =
      '/api/v1/hrm/master/productDetails';
    this.masterPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'masterdata';
    this.masterPostRequestBody['data'] = JSON.stringify(itemDescriptionData);
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.masterPostRequestBody
    );
  }

  getDcDisposition() {
    this.masterGetRequestBody['urlEndPoint'] =
      '/api/v1/hrm/master/dcDisposition';
    this.masterGetRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'masterdata';
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.masterGetRequestBody
    );
  }

  getAffectedDCV1(dcArray) {
    this.masterPostRequestBody['urlEndPoint'] = '/api/v1/hrm/master/affectedDC';
    this.masterPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'masterdata';
    this.masterPostRequestBody['data'] = JSON.stringify(dcArray);
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.masterPostRequestBody
    );
  }

  getAffectedDC(dcArray) {
    this.masterPostRequestBody['urlEndPoint'] = '/api/v2/hrm/master/affectedDC';
    this.masterPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'masterdata';
    this.masterPostRequestBody['data'] = JSON.stringify(dcArray);
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.masterPostRequestBody
    );
  }

  getFolderNames(eventNo) {
    this.eventPostRequestBody['urlEndPoint'] =
      '/api/v1/hrm/events/listOfFolders';
    this.eventPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    this.eventPostRequestBody['data'] = JSON.stringify(eventNo);
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventPostRequestBody
    );
  }

  createFolder(data) {
    this.eventPostRequestBody['urlEndPoint'] =
      '/api/v1/hrm/events/createFolder';
    this.eventPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    this.eventPostRequestBody['data'] = JSON.stringify(data);
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventPostRequestBody
    );
  }

  uploadDocument(data) {
    let baseUrl;
    const urlEndPoint = '/api/v1/hrm/events/uploadDocuments';
    var configUrl = window.location.hostname;
    if (configUrl.includes('stg')) {
      baseUrl = `https://holdandrecall-event-service-stg.apps.cf.np.gc.cahcloud.net`;
    } else {
      baseUrl = `https://holdandrecall-event-service-dev.apps.cf.np.gc.cahcloud.net`;
    }
    const url = baseUrl + urlEndPoint;
    return this.http.post<any>(url, data);
  }

  getDocuments(eventNo) {
    this.eventPostRequestBody['urlEndPoint'] =
      '/api/v1/hrm/events/listOfDocuments';
    this.eventPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    this.eventPostRequestBody['data'] = JSON.stringify(eventNo);
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventPostRequestBody
    );
  }

  getAuditLog(eventNumber) {
    this.masterGetRequestBody['urlEndPoint'] =
      '/api/v1/hrm/master/eventHistory/' + eventNumber;
    this.masterGetRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'masterdata';
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.masterGetRequestBody
    );
  }

  downloadDocument(id) {
    this.eventPostRequestBody['urlEndPoint'] =
      '/api/v1/hrm/events/downloadDocuments';
    this.eventPostRequestBody['data'] = JSON.stringify(id);
    this.eventPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventPostRequestBody,
      { responseType: 'json' }
    );
  }

  downloadReports(url) {
    return this.http.get<any>(url);
  }

  deleteDocument(id) {
    this.eventPostRequestBody['urlEndPoint'] =
      '/api/v1/hrm/events/deleteDocument';
    this.eventPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    this.eventPostRequestBody['data'] = JSON.stringify(id);
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventPostRequestBody
    );
  }

  getEventModificationData(eventNo) {
    this.eventGetRequestBody['urlEndPoint'] =
      '/api/v1/hrm/events/customEventDetails/' + eventNo;
    this.eventGetRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventGetRequestBody
    );
  }

  getEventModificationDraftData(eventNo) {
    this.eventGetRequestBody['urlEndPoint'] =
      '/api/v1/hrm/events/modifications/' + eventNo + '/RECENT';
    this.eventGetRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventGetRequestBody
    );
  }

  updateEventModificationStatus(data) {
    this.eventPostRequestBody['urlEndPoint'] =
      '/api/v1/hrm/events/modifications/statusUpdate';
    this.eventPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    this.eventPostRequestBody['data'] = JSON.stringify(data);
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventPostRequestBody
    );
  }

  getEventAllModificationDraftData(eventNo) {
    this.eventGetRequestBody['urlEndPoint'] =
      '/api/v1/hrm/events/modifications/' + eventNo + '/ALL';
    this.eventGetRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventGetRequestBody
    );
  }

  modifyEvent(eventNo) {
    this.eventGetRequestBody['urlEndPoint'] =
      '/api/v1/hrm/events/modifications/start/' + eventNo;
    this.eventGetRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventGetRequestBody
    );
  }

  getEventStatus(eventNo) {
    this.eventGetRequestBody['urlEndPoint'] =
      '/api/v1/hrm/events/modifications/status/' + eventNo;
    this.eventGetRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventGetRequestBody
    );
  }

  saveModificationDraft(data) {
    this.eventPostRequestBody['urlEndPoint'] =
      '/api/v1/hrm/events/modifications/draft';
    this.eventPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    this.eventPostRequestBody['data'] = JSON.stringify(data);
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventPostRequestBody
    );
  }

  submitModificationEvent(data) {
    this.eventPostRequestBody['urlEndPoint'] =
      '/api/v1/hrm/events/modifications/submit';
    this.eventPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    this.eventPostRequestBody['data'] = JSON.stringify(data);
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventPostRequestBody
    );
  }

  submitEventCreationForm(eventData) {
    this.eventPostRequestBody['urlEndPoint'] =
      '/api/v1/hrm/events/event/status/SUBMITTED';
    this.eventPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    this.eventPostRequestBody['data'] = JSON.stringify(eventData);
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventPostRequestBody
    );
  }

  saveDraftEvent(eventData) {
    this.eventPostRequestBody['urlEndPoint'] =
      '/api/v1/hrm/events/event/status/DRAFT';
    this.eventPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    this.eventPostRequestBody['data'] = JSON.stringify(eventData);
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventPostRequestBody
    );
  }

  getDraftEvent(eventNumber) {
    this.eventGetRequestBody['urlEndPoint'] =
      '/api/v1/hrm/events/event/' + eventNumber;
    this.eventGetRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventGetRequestBody
    );
  }

  updateEventStatus(data) {
    this.eventPostRequestBody['urlEndPoint'] =
      '/api/v1/hrm/events/statusUpdate';
    this.eventPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    this.eventPostRequestBody['data'] = JSON.stringify(data);
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventPostRequestBody
    );
  }

  saveHeaderMsg() {
    this.masterGetRequestBody['urlEndPoint'] =
      '/api/v1/hrm/master/getFlashMessage';
    this.masterGetRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'masterdata';
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.masterGetRequestBody
    );
  }

  closeAcknowledgeTask(data) {
    this.workflowPutRequestBody['urlEndPoint'] =
      '/api/v1/hrm/task/closeAcknowledgeTask';
    this.workflowPutRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'workflow';
    this.workflowPutRequestBody['data'] = JSON.stringify(data);
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.workflowPutRequestBody
    );
  }

  getEventProgressPercentage(dcId) {
    let data;
    let dcSelecetdData = {
      dcIds: [dcId],
    };
    if (!dcId) {
      data = null;
    } else {
      data = JSON.stringify(dcSelecetdData);
    }
    this.workflowPostRequestBody['urlEndPoint'] =
      '/api/v1/hrm/task/getTasksCount';
    this.workflowPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'workflow';
    this.workflowPostRequestBody['data'] = data;
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.workflowPostRequestBody
    );
  }

  getEventProgressDetails(data) {
    this.eventPostRequestBody['urlEndPoint'] =
      '/api/v1/hrm/events/eventByAccount/event';
    this.eventPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    this.eventPostRequestBody['data'] = JSON.stringify(data);
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventPostRequestBody
    );
  }

  getTaskScreenValues(eventNumber) {
    this.workflowGetRequestBody['urlEndPoint'] =
      '/api/v1/hrm/task/getDcTask/' + eventNumber;
    this.workflowGetRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'workflow';
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.workflowGetRequestBody
    );
  }

  getProductAndDcSummary(data) {
    this.eventPostRequestBody['urlEndPoint'] =
      '/api/v1/hrm/events/disposition/summary';
    this.eventPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    this.eventPostRequestBody['data'] = JSON.stringify(data);
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventPostRequestBody
    );
  }

  createTask(data) {
    this.workflowPostRequestBody['urlEndPoint'] = '/api/v1/hrm/task/createTask';
    this.workflowPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'workflow';
    this.workflowPostRequestBody['data'] = JSON.stringify(data);
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.workflowPostRequestBody
    );
  }


  saveGlobalPlanDisposition(param, data) {
    this.eventPostRequestBody['urlEndPoint'] =
      '/api/v1/hrm/events/disposition/' + param;
    this.eventPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    this.eventPostRequestBody['data'] = JSON.stringify(data);
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventPostRequestBody
    );
  }


  saveGlobalPlanDispositionV2(param, data) {
    this.eventPostRequestBody['urlEndPoint'] =
      '/api/v2/hrm/events/disposition/' + param;
    this.eventPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    this.eventPostRequestBody['data'] = JSON.stringify(data);
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventPostRequestBody
    );
  }

  getGlobalDisposition(eventNumber) {
    this.eventGetRequestBody['urlEndPoint'] =
      '/api/v1/hrm/events/disposition/global/' + eventNumber;
    this.eventGetRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventGetRequestBody
    );
  }

  getPlanDisposition(data) {
    this.eventPostRequestBody['urlEndPoint'] =
      '/api/v1/hrm/events/disposition/planDisposition/search';
    this.eventPostRequestBody['data'] = JSON.stringify(data);
    this.eventPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventPostRequestBody
    );
  }

  executeDisposition(data) {
    this.eventPostRequestBody['urlEndPoint'] =
      '/api/v1/hrm/events/disposition/proceedDisposition/search';
    this.eventPostRequestBody['data'] = JSON.stringify(data);
    this.eventPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventPostRequestBody
    );
  }

  saveExecuteDisposition(data) {
    this.eventPostRequestBody['urlEndPoint'] =
      '/api/v1/hrm/events/disposition/proceedDisposition';
    this.eventPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    this.eventPostRequestBody['data'] = JSON.stringify(data);
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventPostRequestBody
    );
  }


  saveExecuteMultipleDisposition(data) {
    this.eventPostRequestBody['urlEndPoint'] =
      '/api/v1/hrm/events/multipleDisposition/proceedDisposition';
    this.eventPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    this.eventPostRequestBody['data'] = JSON.stringify(data);
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventPostRequestBody
    );
  }

  willdCardSearchLot(eventNumber, productNumber, cardinalNumber, textTyped) {
    this.eventGetRequestBody['urlEndPoint'] =
      '/api/v1/hrm/events/lots/' +
      eventNumber +
      '/' +
      productNumber +
      '/' +
      cardinalNumber +
      '/' +
      textTyped;
    this.eventGetRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventGetRequestBody
    );
  }

  willdCardSearchLotV2(eventNumber, productNumber, cardinalNumber) {
    this.eventGetRequestBody['urlEndPoint'] =
      '/api/v2/hrm/events/' +
      eventNumber +
      '/lots?productNumber=' +
      productNumber +
      '&cardinalNumber=' +
      cardinalNumber;
    this.eventGetRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventGetRequestBody
    );
  }

  wildCardSearchAsv(textTyped) {
    this.masterGetRequestBody['urlEndPoint'] =
      '/api/v1/hrm/master/supplier/' + textTyped;
    this.masterGetRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'masterdata';
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.masterGetRequestBody
    );
  }

  getQuarantineResponse() {
    this.masterGetRequestBody['urlEndPoint'] =
      '/api/v1/hrm/master/quarantineResponseType';
    this.masterGetRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'masterdata';
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.masterGetRequestBody
    );
  }

  createDispositionTask(data) {
    this.workflowPostRequestBody['urlEndPoint'] =
      '/api/v1/hrm/task/createDispositionTask';
    this.workflowPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'workflow';
    this.workflowPostRequestBody['data'] = JSON.stringify(data);
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.workflowPostRequestBody
    );
  }

  saveQuarantine(data) {
    this.eventPostRequestBody['urlEndPoint'] = '/api/v1/hrm/events/quarantine';
    this.eventPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    this.eventPostRequestBody['data'] = JSON.stringify(data);
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventPostRequestBody
    );
  }

  deleteQuarantine(id) {
    const body = {
      baseUrl: this.environment.apiConfig.holdUrl + 'event',
      urlEndPoint: '/api/v1/hrm/events/quarantine/' + id,
      method: 'DELETE',
    };
    return this.http.post<any>(this.environment.apiConfig.apiUrl, body);
  }

  getPendingDispositionDatat(data) {
    this.eventPostRequestBody['urlEndPoint'] =
      '/api/v1/hrm/events/quarantine/quarantineDispositionDetails';
    this.eventPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    this.eventPostRequestBody['data'] = JSON.stringify(data);
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventPostRequestBody
    );
  }

  closeQuarantineTask(data) {
    this.workflowPutRequestBody['urlEndPoint'] =
      '/api/v1/hrm/task/closeQuarantineTask';
    this.workflowPutRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'workflow';
    this.workflowPutRequestBody['data'] = JSON.stringify(data);
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.workflowPutRequestBody
    );
  }

  getQuarantinePaginationData(data) {
    this.eventPostRequestBody['urlEndPoint'] = eventApiUrl.getQuarantineTblData;
    this.eventPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    this.eventPostRequestBody['data'] = JSON.stringify(data);
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventPostRequestBody
    );
  }

  getQuarantineLots(data) {
    this.eventGetRequestBody['urlEndPoint'] =
      '/api/v2/hrm/events/' +
      data['eventNumber'] +
      '/quarantine-lots?productNumber=' +
      data['productNumber'] +
      '&cardinalNumber=' +
      data['cardinalNumber'] + 
      '&dcCode=' + 
      data['dcCode'];
    this.eventGetRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventGetRequestBody
    );
  }

  getApiRequest(baseUrl, urlEndPoint, param?) {
    return this.http.post<any>(this.environment.apiConfig.apiUrl, {
      baseUrl: this.environment.apiConfig.holdUrl + baseUrl,
      urlEndPoint: param ? urlEndPoint + param : urlEndPoint,
      method: 'get',
    });
  }

  postApiRequest(baseUrl, urlEndPoint, data?, param?) {
    return this.http.post<any>(this.environment.apiConfig.apiUrl, {
      baseUrl: this.environment.apiConfig.holdUrl + baseUrl,
      urlEndPoint: param ? urlEndPoint + param : urlEndPoint,
      method: 'POST',
      data: data ? JSON.stringify(data) : null,
    });
  }

  closeDispositionTask(data) {
    this.workflowPutRequestBody['urlEndPoint'] =
      '/api/v1/hrm/task/closeDispositionTask';
    this.workflowPutRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'workflow';
    this.workflowPutRequestBody['data'] = JSON.stringify(data);
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.workflowPutRequestBody
    );
  }

  dispositionQRA(data) {
    this.eventPostRequestBody['urlEndPoint'] =
      '/api/v1/hrm/events/disposition/qraApprover';
    this.eventPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    this.eventPostRequestBody['data'] = JSON.stringify(data);
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventPostRequestBody
    );
  }

  dispositionStatusUpdate(data) {
    this.eventPostRequestBody['urlEndPoint'] =
      '/api/v1/hrm/events/disposition/statusUpdate';
    this.eventPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    this.eventPostRequestBody['data'] = JSON.stringify(data);
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventPostRequestBody
    );
  }

  getAuditData(data) {
    this.masterPostRequestBody['urlEndPoint'] = '/api/v1/hrm/master/eventAudit';
    this.masterPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'masterdata';
    this.masterPostRequestBody['data'] = JSON.stringify(data);
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.masterPostRequestBody
    );
  }

  getReportType(source) {
    this.eventGetRequestBody['urlEndPoint'] =
      '/api/v1/hrm/events/reports/' + source;
    this.eventGetRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventGetRequestBody
    );
  }

  getUserDCAllocated(userId: string): Observable<any> {
    this.userGetRequestBody['urlEndPoint'] =
      '/api/v1/hrm/users/userDcMapping/' + userId;
    this.userGetRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'user';
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.userGetRequestBody
    );
  }

  massUploadProduct(data) {
    const urlEndPoint = 'api/v1/hrm/events/productMassUpload';
    return this.http.post<any>(
      this.environment.apiConfig.reportUrl + urlEndPoint,
      data
    );
  }

  uploadFile(data) {
    const urlEndPoint = 'api/v1/hrm/events/productMassUpload/generate';
    return this.http.post<any>(
      this.environment.apiConfig.reportUrl + urlEndPoint,
      data
    );
  }

  downloadExportCustomerSearch(data) {
    this.eventPostRequestBody['urlEndPoint'] =
      '/api/v1/hrm/events/affectedCustomerDashboard/excel/download';
    this.eventPostRequestBody['data'] = JSON.stringify(data);
    this.eventPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventPostRequestBody,
      { responseType: 'json' }
    );
  }

  downloadExportDistributionCenter(data) {
    this.eventPostRequestBody['urlEndPoint'] =
      '/api/v1/hrm/master/distribution-centre/sort/excel/download';
    this.eventPostRequestBody['data'] = JSON.stringify(data);
    this.eventPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'masterdata';
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventPostRequestBody,
      { responseType: 'json' }
    );
  }

  downloadDocumentProductSearch(data) {
    this.eventPostRequestBody['urlEndPoint'] =
      '/api/v1/hrm/master/productSearch/excel/download';
    this.eventPostRequestBody['data'] = JSON.stringify(data);
    this.eventPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'masterdata';
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventPostRequestBody,
      { responseType: 'json' }
    );
  }

  downloadDocumentInternalUser(data) {
    this.eventPostRequestBody['urlEndPoint'] =
      '/api/v1/hrm/users/search/excel/download';
    this.eventPostRequestBody['data'] = JSON.stringify(data);
    this.eventPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'user';
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventPostRequestBody,
      { responseType: 'json' }
    );
  }

  downloadDocumentEventSearch(data) {
    this.eventPostRequestBody['urlEndPoint'] =
      '/api/v1/hrm/events/eventReceiver/excel/download';
    this.eventPostRequestBody['data'] = JSON.stringify(data);
    this.eventPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventPostRequestBody,
      { responseType: 'json' }
    );
  }

  saveBillingReport(data) {
    this.eventPostRequestBody['urlEndPoint'] = '/api/v1/hrm/events/billing';
    this.eventPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    this.eventPostRequestBody['data'] = JSON.stringify(data);
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventPostRequestBody
    );
  }

  getBillingReport(eventNumber) {
    this.eventGetRequestBody['urlEndPoint'] =
      '/api/v1/hrm/events/billing' + '/' + eventNumber;
    this.eventGetRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventGetRequestBody
    );
  }

  downloadProcessingReportLetter(data, fileType) {
    this.eventPostRequestBody['urlEndPoint'] =
      '/api/v1/hrm/events/billing/reports/' + fileType;
    this.eventPostRequestBody['data'] = JSON.stringify(data);
    this.eventPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventPostRequestBody,
      { responseType: 'json' }
    );
  }

  downloadDashboardReports(data, reportType) {
    let baseUrl;
    const urlEndPoint = '/api/v1/hrm/events/report/' + reportType;
    var configUrl = window.location.hostname;
    if (configUrl.includes('stg')) {
      baseUrl = `https://holdandrecall-event-service-stg.apps.cf.np.gc.cahcloud.net`;
    } else {
      baseUrl = `https://holdandrecall-event-service-dev.apps.cf.np.gc.cahcloud.net`;
    }
    const url = baseUrl + urlEndPoint;
    return this.http.post<any>(url, data);
  }

  getCustomerDataByAck(baseUrl, urlEndPoint, data?, param?) {
    return this.http.post<any>(this.environment.apiConfig.apiUrl, {
      baseUrl: this.environment.apiConfig.holdUrl + baseUrl,
      urlEndPoint: param ? urlEndPoint + param : urlEndPoint,
      method: 'POST',
      data: data ? JSON.stringify(data) : null,
    });
  }

  downloadExportMsg(data, iiqid) {
    this.eventPostRequestBody['urlEndPoint'] =
      '/api/v1/hrm/workflow/exportAllMessages' + '?iiqUserId=' + iiqid;
    this.eventPostRequestBody['data'] = JSON.stringify(data);
    this.eventPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'workflow';
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventPostRequestBody,
      { responseType: 'json' }
    );
  }

  getMfgGroups() {
    this.masterGetRequestBody['urlEndPoint'] = '/api/v1/hrm/master/mfgGroups';
    this.masterGetRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'masterdata';
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.masterGetRequestBody
    );
  }

  setIsEventReceiverFlagValue(newValue: boolean): void {
    this.isEventReceiverFlagSubject.next(newValue);
  }

  getIsEventReceiverFlagValue(): boolean {
    return this.isEventReceiverFlagSubject.value;
  }

  getCreateEventAllDropDownList() {
    this.masterGetRequestBody['urlEndPoint'] =
      '/api/v1/hrm/master/createEvent/allDropDownList';
    this.masterGetRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'masterdata';
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.masterGetRequestBody
    );
  }

  exprotEventDashborad(data) {
    this.eventPostRequestBody['urlEndPoint'] =
      '/api/v1/hrm/events/eventDashboard/export';
    this.eventPostRequestBody['data'] = JSON.stringify(data);
    this.eventPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventPostRequestBody,
      { responseType: 'json' }
    );
  }

  getProductInformation(
    eventNumber: string,
    eventStatus: string,
    eventModified: boolean
  ): Promise<any> {
    return this.http
      .get<any>(
        this.environment.apiConfig.holdUrl +
          'event' +
          eventApiUrl.productInformation +
          eventNumber +
          '/' +
          eventStatus +
          '/' +
          eventModified
      )
      .toPromise();
  }

  getLotNumbersFromSelection(data) {
    this.eventPostRequestBody['urlEndPoint'] =
      '/api/v1/hrm/events/getLotNumbers';
    this.eventPostRequestBody['data'] = JSON.stringify(data);
    this.eventPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventPostRequestBody,
      { responseType: 'json' }
    );
  }


  getLotNumbersFromSelectionV2(data, eventNumber) {
    this.eventPostRequestBody['urlEndPoint'] =
      `/api/v2/hrm/events/${eventNumber}/get-lots`;
    this.eventPostRequestBody['data'] = JSON.stringify(data);
    this.eventPostRequestBody['baseUrl'] =
      this.environment.apiConfig.holdUrl + 'event';
    return this.http.post<any>(
      this.environment.apiConfig.apiUrl,
      this.eventPostRequestBody,
      { responseType: 'json' }
    );
  }
}
